var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.33333C1 1.59695 1.59695 1 2.33333 1H4.51949C4.80645 1 5.06121 1.18362 5.15195 1.45585L6.15049 4.45147C6.25541 4.76622 6.11292 5.11021 5.81618 5.25858L4.31134 6.011C5.04617 7.64081 6.35919 8.95383 7.989 9.68866L8.74142 8.18382C8.88979 7.88708 9.23378 7.74459 9.54853 7.84951L12.5442 8.84805C12.8164 8.93879 13 9.19355 13 9.48051V11.6667C13 12.403 12.403 13 11.6667 13H11C5.47715 13 1 8.52285 1 3V2.33333Z",
    stroke: "#75829A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b72e285bb01b0e7c17b095b964be3e25.svg";
export { ForwardRef as ReactComponent };